/**
 * NotAccessiblePage
 *
 * This is the page we show when the user visits a url that doesn't have a permission
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import notFoundImg from '../../assets/images/not_found.png';
import notAuthorized from '../../assets/images/not_authorized.png';
import './style.css';
const PAGE_NOT_FOUND = __('The page you are looking is not existing.');
const NOT_AUTHORIZED = __('You are not authorized to visit this page.');
class ErrorPage extends PureComponent {
  constructor() {
    super(...arguments);
    this.redirectToHome = () => {
      const {
        PARTNERS_SITE
      } = process.env;
      const defaultUrl = PARTNERS_SITE === 'true' ? '/home/mytasks' : '/app/home';
      window.location.href = defaultUrl;
    };
    this.renderMessage = () => {
      const {
        notFound,
        hideHomeLink,
        message: msg
      } = this.props;
      if (msg) {
        return /*#__PURE__*/React.createElement("h1", {
          className: "not-existing-msg"
        }, msg, " ");
      }
      let message = notFound ? PAGE_NOT_FOUND : NOT_AUTHORIZED;
      message = hideHomeLink ? "".concat(message, " ").concat(__("Please contact"), " ") : "".concat(message, " ").concat(__("Navigate to"), " ");
      return /*#__PURE__*/React.createElement("h1", {
        className: "not-existing-msg"
      }, "".concat(message, " "), hideHomeLink ? /*#__PURE__*/React.createElement("a", {
        href: "mailto:TAP_Support@tekion.com",
        style: {
          textDecoration: 'none'
        }
      }, __('TAP Support.')) : /*#__PURE__*/React.createElement("a", {
        href: "javascript:void()",
        onClick: this.redirectToHome,
        style: {
          textDecoration: 'none'
        }
      }, __('Home.')));
    };
  }
  render() {
    const {
      notFound
    } = this.props;
    const image = notFound ? notFoundImg : notAuthorized;
    return /*#__PURE__*/React.createElement("article", null, /*#__PURE__*/React.createElement("img", {
      className: "not-existing-img",
      src: image,
      height: "30%",
      width: "30%",
      alt: __('Not found')
    }), this.renderMessage());
  }
}
ErrorPage.propTypes = {
  notFound: PropTypes.bool,
  hideHomeLink: PropTypes.bool,
  message: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
};
ErrorPage.defaultProps = {
  notFound: false,
  hideHomeLink: false,
  message: ''
};
export default ErrorPage;